// extracted by mini-css-extract-plugin
export default {"social-media-links":"cPS549X","social-media-links__list":"KXaPYCw","social-media-links__item":"RGfIqYH"};